module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M32 2c0-1.106-.894-2-2-2H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2zm-8 19a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2zm0-8a1 1 0 0 1-1 1H13a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/align-right-1.js
// module id = 987
// module chunks = 14